import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import { store, persistedStore } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import SignupContextProvider from "./context/SignUpContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <SignupContextProvider>
    <Provider store={store}>
      <PersistGate persistor={persistedStore}>
        <App />
      </PersistGate>
    </Provider>
  </SignupContextProvider>
  // </React.StrictMode>
);
